
  import { mapGetters } from 'vuex'
  import cms from '~/mixins/common/cms'
  import playGames from '~/mixins/common/play-games'
  // Define a constant for sub-slider page size
  const SUB_SLIDER_PAGE_SIZE = 4
  export default {
    mixins: [cms, playGames],
    data() {
      return {
        slider: 0,
        subSliderModel: 0
      }
    },
    computed: {
      ...mapGetters({
        desktopSlider: 'cms/desktopSlider'
      }),
      visibleItems() {
        return this.getVisibleItems(this.desktopSlider?.items) || []
      },
      subSliderContentSliderCount() {
        // Calculate number of sub-slider pages
        return Math.ceil(this.visibleItems.length / SUB_SLIDER_PAGE_SIZE)
      },
      getSubSliderContentBySliderIndex() {
        const sliderContent = this.visibleItems
        return v =>
          sliderContent.slice(
            v * SUB_SLIDER_PAGE_SIZE,
            v * SUB_SLIDER_PAGE_SIZE + SUB_SLIDER_PAGE_SIZE
          )
      },
      sliderColLength() {
        const sliderContent = this.getSubSliderContentBySliderIndex(this.subSliderModel)?.length
        if (sliderContent === 4) return 3
        if (sliderContent === 3) return 4
        if (sliderContent === 2) return 6
        return 12
      }
    },
    watch: {
      slider(value) {
        // Dynamically set subSliderModel based on slider index
        this.subSliderModel = Math.floor(value / SUB_SLIDER_PAGE_SIZE)
      }
    },
    methods: {
      // Calculate absolute index for sub-slider item
      getAbsoluteIndex(index) {
        return index + SUB_SLIDER_PAGE_SIZE * this.subSliderModel
      },
      handleSubSliderClick(index) {
        this.slider = this.getAbsoluteIndex(index)
      },
      getThumbnail(item) {
        const path = this.getLocaleLang(item.thumbnail_path)
        return path
          ? this.cmsImageLink({ path, code: this.desktopSlider.component_code })
          : '/static/no-image.jpeg'
      }
    }
  }
